var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApolloClient, InMemoryCache, createHttpLink, } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
var CTK_STORAGE_KEY = "tmn-ctk";
var DO_NOT_TRACK_STORAGE_KEY = "tmn-dnt";
var DO_NOT_TRACK_DEFAULT = "1";
var FORCE_GROUPS_PARAM = "prforceGroups";
var FORCE_GROUPS_HEADER = "indeed-prforce-groups";
var CTK_HEADER = "indeed-ctk";
var DO_NOT_TRACK_HEADER = "indeed-dnt";
var PLACEMENT_ID_HEADER = "indeed-placementid";
function getForceGroupsFromUrl() {
    try {
        return new URLSearchParams(window.location.search).get(FORCE_GROUPS_PARAM);
    }
    catch (_a) {
        return null;
    }
}
function getCtkFromLocalStorage() {
    try {
        return localStorage.getItem(CTK_STORAGE_KEY);
    }
    catch (_a) {
        return null;
    }
}
function getDoNotTrackFromLocalStorage() {
    var _a;
    try {
        return ((_a = localStorage.getItem(DO_NOT_TRACK_STORAGE_KEY)) !== null && _a !== void 0 ? _a : DO_NOT_TRACK_DEFAULT);
    }
    catch (_b) {
        // Default to Do Not Track if nothing is found
        return DO_NOT_TRACK_DEFAULT;
    }
}
export function getClient(uri, placementId) {
    var httpLink = createHttpLink({
        uri: uri || "/graphql",
        credentials: "include",
    });
    var ctkLink = setContext(function (_, _a) {
        var _b, _c, _d, _e;
        var headers = _a.headers;
        var ctk = getCtkFromLocalStorage();
        var dnt = getDoNotTrackFromLocalStorage();
        var forceGroups = getForceGroupsFromUrl();
        return {
            headers: __assign(__assign(__assign(__assign(__assign({}, headers), (ctk && (_b = {}, _b[CTK_HEADER] = ctk, _b))), (dnt && (_c = {}, _c[DO_NOT_TRACK_HEADER] = dnt, _c))), (placementId && (_d = {}, _d[PLACEMENT_ID_HEADER] = placementId, _d))), (forceGroups !== null && (_e = {}, _e[FORCE_GROUPS_HEADER] = forceGroups, _e))),
        };
    });
    return new ApolloClient({
        link: ctkLink.concat(httpLink),
        cache: new InMemoryCache(),
    });
}
